//============================================================================
// Name        : printerActions.ts
// Purpose     : Define store Printer actions
// Created     : 2019-07-31
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

import { IPrinterModel, IPrinterOption, IPrintState, PrinterActions } from "../types";

// Define base Action interface
export interface IPrinterAction {
    type: PrinterActions;
    payload: any;
}

//================================ Actions ===================================

//============================================================================
// Fetch printers and populate them in the store
//============================================================================
export interface IFetchPrintersAction extends IPrinterAction {
    printers: IPrinterModel[];
}
export function fetchPrinters(state: IPrintState, action: IFetchPrintersAction): IPrintState {
    let savePrinter = localStorage.getItem("mf_print_save_printer");
    if (!savePrinter) {
        localStorage.setItem("mf_print_save_printer", "true");
    }
    savePrinter = localStorage.getItem("mf_print_save_printer");
    let stateSavePrinter = true;
    if (savePrinter && (savePrinter == "true")) {
        stateSavePrinter = true;
        state.defaultPrinter = parseInt(localStorage.getItem("mf_print_default_printer"), 10);
        if (state.defaultPrinter) {
            const selectedOption = action.printers.find(x => x.id == state.defaultPrinter);
            if (selectedOption) {
                state.selectedPrinter = {
                    value: selectedOption.id.toString(),
                    label: selectedOption.name
                };
            }
        }
    }
    return {
        ...state,
        savePrinter: stateSavePrinter,
        items: action.printers.map((p: IPrinterModel) => {
            return {
                value: p.id.toString(),
                label: p.name
            } as IPrinterOption;
        })
    };
}

//============================================================================
// Store the flag for save the selected printer permanently
//============================================================================
export interface ISetSavePrinterAction extends IPrinterAction {
    value: boolean;
}
export function setSavePrinter(state: IPrintState, action: ISetSavePrinterAction): IPrintState {
    if (action.value) {
        localStorage.setItem("mf_print_save_printer", "true");
    }
    else {
        localStorage.removeItem("mf_print_save_printer");
    }
    return { ...state, savePrinter: action.value };
}

//============================================================================
// Store the deafult printer
//============================================================================
export interface ISaveDefaultPrinterAction extends IPrinterAction {
    printer: IPrinterOption;
}
export function saveDefaultPrinter(state: IPrintState, action: ISaveDefaultPrinterAction): IPrintState {
    localStorage.setItem("mf_print_default_printer", action.printer.value);
    return { ...state, selectedPrinter: action.printer };
}

//============================================================================
// Store the selected printer in the store
//============================================================================
export interface ISetSelectedPrinterAction extends IPrinterAction {
    printer: IPrinterOption;
}
export function setSelectedPrinter(state: IPrintState, action: ISetSelectedPrinterAction): IPrintState {
    return { ...state, selectedPrinter: action.printer };
}

//============================================================================
// Store print state
//============================================================================
export interface ISetPrintStateAction extends IPrinterAction {
    props: Partial<IPrintState>;
}
export function setPrintState(state: IPrintState, action: ISetPrintStateAction): IPrintState {
    return {
        ...state,
        ...action.payload.props
    };
}
